import {lazyAfterLoad} from '../../utils/lazyAfterLoad'


export default lazyAfterLoad(() => import(/* webpackChunkName: "modal" */ './Modal'))
